export const layout = {
  container: {
    maxWidth: ['layout', null, null, null, 'layoutPlus'],
    width: 'container',
    mx: 'auto'
  },
  wideContainer: {
    maxWidth: [null, null, null, null, 'widePlus'],
    width: 'auto',
    mx: 'auto'
  }
}
